import { useContext, useEffect, useRef } from "react"

import ApiRoot from "api/apiRoot"
import { UserContext } from "context/UserContext"
import { env } from "env"
import { API_ROOT_HEADER, CID_HEADER } from "utilities/constants"
import { getHeaderFromHeaders } from "utilities/helpers"
import { log, SHOW_LOGS } from "utilities/logging"

const CIDWrapper = ({ children }: React.PropsWithChildren) => {
  const { setCid } = useContext(UserContext)
  const isLoadingRef = useRef(false)

  useEffect(
    function setCid_and_instantiateApi() {
      // Prevent double execution in React Strict Mode
      if (isLoadingRef.current) {
        return
      }
      isLoadingRef.current = true

      if (!env.DEV) {
        log(SHOW_LOGS.CLIENT_ID, "Requesting CDN headers")
        const req = new XMLHttpRequest()
        req.open("GET", window.location.href, false)
        req.send(null)

        const headers = req.getAllResponseHeaders().toLowerCase()

        if (headers) {
          const cid_header = getHeaderFromHeaders(headers, CID_HEADER)

          if (cid_header) {
            log(SHOW_LOGS.CLIENT_ID, "Using CID:", cid_header)
            setCid(cid_header)
          }

          const api_root = getHeaderFromHeaders(headers, API_ROOT_HEADER)

          if (api_root) {
            log(SHOW_LOGS.API_ROUTE, "Using API_ROOT:", api_root)
            ApiRoot.connect(api_root)
          }
        }
      } else {
        // NOT_PRODUCTION
        import("data/colleges").then(({ COLLEGES }) => {
          const activeCollege = COLLEGES.find(
            college => college.currentlyActive
          )
          if (activeCollege) {
            setCid(activeCollege.collegeId)
            log(
              SHOW_LOGS.CLIENT_ID,
              "Using Local CID:",
              activeCollege.collegeId
            )
            log(SHOW_LOGS.API_ROUTE, "Using BASE_API:", env.VITE_API_BASE)

            ApiRoot.connect(env.VITE_API_BASE)
          }
        })
      }
    },
    [setCid]
  )

  return children
}

export default CIDWrapper
